<script setup lang="ts">
import { computed } from 'vue';
import Popover from 'primevue/popover';
import UserOptions from './UserOptions.vue';
import { useTopBarPopover } from './useTopBarPopover';
import { UserAvatar } from '@/components/common';
import { useUserStore } from '@/stores/user';

// The profile now lives only in the top bar — it used to sit at the foot of the sidebar.
const userStore = useUserStore();
const userLink = computed(() => userStore.userLink);

const { popover, toggle, hide, alignToTrigger } = useTopBarPopover();
</script>

<template>
  <button type="button"
    class="topbar-user"
    :aria-label="`Account: ${userLink.label}`"
    @click="toggle">
    <UserAvatar :avatar-url="userLink.icon"
      :user-name="userLink.label"
      :show-name="false"
      :loading="userLink.loading"
      :size="20" />
    <span v-if="!userLink.loading" class="topbar-user__name">{{ userLink.label }}</span>
  </button>

  <Popover ref="popover" @show="alignToTrigger">
    <UserOptions @closePopup="hide" />
  </Popover>
</template>

<style scoped lang="scss">
@use '../../assets/variables.module' as *;
.topbar-user {
  display: flex;
  align-items: center;
  height: 36px;
  max-width: 280px;
  // Lets the name ellipsis rather than push the bar wider on narrow viewports.
  min-width: 0;
  padding: 8px;
  border: 1px solid hsl(206, 25%, 92%);
  border-radius: 8px;
  background-color: transparent;
  color: hsl(210, 11%, 15%);
  font-size: 14px;
  font-weight: 500;
  line-height: 20px;
  cursor: pointer;
  transition: background-color 0.15s ease;

  &:hover {
    background-color: hsl(210, 20%, 96%);
  }

  &:focus-visible {
    outline: 2px solid $primary-color;
    outline-offset: -2px;
  }
}
.topbar-user__name {
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
</style>
